import { usePersonSchema } from '@/domain/mitarbeiter/features/anlageassistent/hooks/schema/usePersonSchema';
import { SubStepKey } from '@/domain/mitarbeiter/features/anlageassistent/types/types';
import z from 'zod';

export function useFormSchema() {
  const { PersoenlichesSchema, KontaktSchema } = usePersonSchema();

  return z.object({
    person: z.object({
      persoenliches: PersoenlichesSchema,
      kontakt: KontaktSchema,
    }),
  });
}

export function useSubStepSchemasMap() {
  const formSchema = useFormSchema();

  return {
    'person.persoenliches': formSchema.shape.person.shape.persoenliches,
    'person.kontakt': formSchema.shape.person.shape.kontakt,
  } satisfies Record<SubStepKey, z.ZodTypeAny>;
}
